import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core/';
import Button from '../Button';

const styles = makeStyles(() => ({
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  price: {
    opacity: 0.6,
    fontWeight: 700,
  },
  content: {
    fontWeight: 700,
  },
}));

interface PriceButtonProps {
  handleSubmit: () => void;
  content: string;
  price: string;
  disabled?: boolean;
  dataTestId: string;
}

const PriceButton = ({
  handleSubmit,
  content,
  price,
  disabled = false,
  dataTestId,
}: PriceButtonProps) => {
  const classes = styles();

  return (
    <Button onClick={handleSubmit} disabled={disabled} data-testid={dataTestId}>
      <Box className={classes.buttonContainer}>
        <Typography variant="subtitle2" className={classes.content}>
          {content}
        </Typography>
        <Typography className={classes.price}>{price}</Typography>
      </Box>
    </Button>
  );
};

export default PriceButton;
